import { useState } from "react";

import iconCommentDelete from "../assets/images/comment-delete.svg";
import iconCommentEdit from "../assets/images/comment-edit.svg";
import iconCommentPlace from "../assets/images/comment-place.svg";
import iconQuestionCheck from "../assets/images/comment-question-check.svg";
import iconQuestionUnCheck from "../assets/images/comment-question-uncheck.svg";
import iconAddCommentBlue from "../assets/images/meeting-comments-add-blue.svg";
import iconAddComment from "../assets/images/meeting-comments-add.svg";
import iconCommentsBigBlack from "../assets/images/meeting-comments-bg-black.svg";
import iconCommentsBigBlue from "../assets/images/meeting-comments-bg-blue.svg";
import iconMarkAsQuestion from "../assets/images/meeting-comments-mark-as-question.svg";
import iconChevronNext from "../assets/images/meeting-comments-next.svg";
import iconChevronPrevious from "../assets/images/meeting-comments-previous.svg";
import iconCommentSending from "../assets/images/meeting-comments-sending.svg";
import user4 from "../assets/images/user4.png";
import CommentData from "../data/comments";

const Comments = () => {
  const [data, setData] = useState(() => CommentData.getComments());

  const [showComments, setShowComments] = useState(false);
  // const [showReplies, setShowReplies] = useState(false);
  // const [showInputReplied, setShowInputReplied] = useState(false);
  const [addShowComment, setShowAddComment] = useState(false);
  const [markAsQuestion, setMarkAsQuestion] = useState(false);
  const [commentIndex, setCommentIndex] = useState(1);
  const [newComment, setNewComment] = useState("");
  const [newCommentError] = useState(false);
  const [newCommentStatus, setNewCommentStatus] = useState("");
  const [newReply, setNewReply] = useState("");
  const [confirmDeleteComment, setConfirmDeleteComment] = useState(null);

  const showCommentsHandler = () => {
    setShowComments(!showComments);
    setShowAddComment(false);
    setCommentIndex(0);
  };

  // const showInputRepliedHandler = () => {
  //   setShowReplies(false);
  //   setShowInputReplied(!showInputReplied);
  // };
  //
  // const showRepliesHandler = () => {
  //   setShowReplies(!showReplies);
  //   setShowInputReplied(false);
  // };

  const addCommentHandler = () => {
    setShowComments(false);
    setShowAddComment(!addShowComment);
    setNewCommentStatus("");
  };

  const commentPreviou = () => {
    setCommentIndex((i) => i - 1);
    setNewReply("");
    setData(data);
    // setShowReplies(false);commentPrevious
  };

  const commentNext = (e) => {
    setCommentIndex((i) => i + 1);
    setNewReply("");
    // setShowReplies(false);
    // setShowInputReplie(false);
    console.log(data.length, e);
  };

  const addNewComment = () => {
    const addNew = [...data];
    addNew.push({
      id: data.length + 1,
      comment: newComment,
      reply: [],
    });
    setData(addNew);
    setNewComment("");
    setShowAddComment(false);
  };

  const addNewCommentWithInterval = () => {
    setNewCommentStatus("sending");
    setTimeout(() => {
      setNewCommentStatus("sent");
    }, 3000);
    setTimeout(() => {
      addNewComment();
    }, 5000);
  };

  const errorSendNewComment = () => {
    setNewCommentStatus("error");
    setTimeout(() => {
      setNewCommentStatus("");
    }, 3000);
  };

  const deleteComment = (id) => {
    setConfirmDeleteComment("question");
    if (confirmDeleteComment === "yes") {
      const befortDelete = [...data];
      const newData = befortDelete.filter((q) => q.id !== id);
      setData(newData);
      // setShowInputReplie(false);
      // setShowReplies(false);
      setData(newData);
      console.log(data.length - 1, commentIndex);
      // if (data.length- 1 - commentIndex < 1) {
      //   setCommentIndex (commentIndex ++)
      // }
    }
  };

  // const addNewReply = (id) => {
  //   const addNew = [...data];
  //   addNew[id - 1].reply.push({
  //     id: addNew.length + 1,
  //     reply: newReply,
  //     question: markAsQuestion,
  //   });
  //   // setShowInputReplie(false);
  //   // setShowReplies(false);
  //   setData(addNew);
  //   setNewReply("");
  // };

  return (
    <div className="comments-container">
      <div className="btn-group-comments">
        <div className={`btn-comments ${showComments ? "active" : null} `} onClick={showCommentsHandler}>
          <img alt="" src={showComments ? iconCommentsBigBlue : iconCommentsBigBlack} width={52} />
          {data.length > 0 && <span className="comment-lenght">{data.length}</span>}
        </div>
        <div className="btn-comment-controllers">
          {data.length > 0 && (
            <>
              <div
                className={`btn btn-comment-previous ${
                  addShowComment ? "btn-comment-disable" : null || (commentIndex === 0 && "btn-comment-disable")
                } `}
                onClick={data.length - commentIndex < data.length && commentPreviou}>
                <img alt="" src={iconChevronPrevious} />
              </div>
              <div
                className={`btn btn-comment-next ${
                  addShowComment ? "btn-comment-disable" : null || addShowComment || (data.length - commentIndex < 3 && "btn-comment-disable")
                } `}
                onClick={data.length - commentIndex > 2 && commentNext}>
                <img alt="" src={iconChevronNext} />
              </div>
            </>
          )}
          <div className="btn btn-comment-add" onClick={addCommentHandler}>
            <img alt="" src={addShowComment ? iconAddCommentBlue : iconAddComment} />
          </div>
        </div>
      </div>

      {showComments && data.length === 0 && (
        <div className="comment-items">
          <div className="single-comment no-comment">
            <span>Lorem ipsum dolor sit amet consectetur...</span>
          </div>
        </div>
      )}

      {showComments && data.length > 0 && (
        <div className="comment-items">
          <div
            className={`single-comment ${data.length === 1 && "comment-lenght-1"} ${commentIndex === 0 && "active-comment"}
            `}>
            <div>
              <img alt="" src={user4} className="author-avatar" />
            </div>
            <div className="single-comment-active">
              <div className="space-between w-210">
                <div className="comment-info">
                  <span className="bold p-l-0"> David </span>
                  <span> 2m </span>
                  <span className="flex">
                    <img alt="" src={iconCommentPlace} width={16} />
                    12:32
                  </span>
                  {commentIndex === 0 && data[commentIndex].question && <img alt="" src={iconMarkAsQuestion} width={12} />}
                </div>
                {commentIndex === 0 && (
                  <div className="flex">
                    <div className="flex">
                      <img alt="" src={iconCommentEdit} width={16} className="pointer m-r-5" />
                    </div>
                    <div className="flex" onClick={() => deleteComment(data[commentIndex + 1].id)}>
                      <img alt="" src={iconCommentDelete} width={16} className="pointer" />
                    </div>
                  </div>
                )}
              </div>
              <div className={`comment-text ${("a", commentIndex, "b", data.length)}`}>{data[commentIndex].comment}</div>
            </div>
          </div>
          {data.length > 1 && data[commentIndex + 1] && (
            <div className={`single-comment AcommentIndex+1 ${commentIndex !== 0 && "active-comment"}`}>
              <div>
                <img alt="" src={user4} className="author-avatar" />
              </div>
              <div className="single-comment-active">
                <div className="space-between w-210">
                  <div className="comment-info">
                    <span className="bold p-l-0"> Andy </span>
                    <span> 2m </span>
                    <span className="flex">
                      <img alt="" src={iconCommentPlace} width={16} />
                      08:21
                    </span>
                    {commentIndex !== 0 && data[commentIndex + 1].question && <img alt="" src={iconMarkAsQuestion} width={12} />}
                  </div>
                  {commentIndex !== 0 && (
                    <div className="flex">
                      <div className="flex">
                        <img alt="" src={iconCommentEdit} width={16} className="pointer m-r-5" />
                      </div>
                      <div className="flex" onClick={() => deleteComment(data[commentIndex + 1].id)}>
                        <img alt="" src={iconCommentDelete} width={16} className="pointer" />
                      </div>
                    </div>
                  )}
                </div>
                <div className="comment-text">
                  {confirmDeleteComment === "question" ? (
                    <div className="p-tb-20">
                      <div> Do you want to remove this comment?</div>
                      <div className="flex-end m-t-10">
                        <span className="p-r-10 pointer bold">No</span>
                        <span className="pointer bold">Yes</span>
                      </div>
                    </div>
                  ) : (
                    data[commentIndex + 1].comment
                  )}
                </div>
                <div className="single-comment-footer">
                  {/* <div className="single-comment-footer-items">
                  <span>99 days ago</span>
                  <span className="flex pointer" onClick={showInputReplieHandler}>
                    <img alt="" src={showInputReplie ? iconCommentsBlue : iconComments} width="12" className="m-r-5"/>
                    <span className={showInputReplie && 'text-bule'}>reply</span>
                  </span>
                  {data[commentIndex +1].reply.length > 0 &&
                    <span className="flex-end pointer" onClick={showRepliesHandler}>
                      <img alt="" src={iconComments} width="12" className="m-r-5"/>
                      <span className="w-75">
                        {showReplies ? 'Hide' : 'Show'} replies ({data[commentIndex +1].reply.length})
                      </span>
                    </span>
                  }
                </div> */}
                  <div className="replay">
                    <div className={`your-reply ${newReply.length > 0 ? null : "hidden-border"} `}>
                      <div className="align-items-center">
                        <img alt="" src={user4} className="author-avatar you" />
                        <input type="text" onChange={(e) => setNewReply(e.target.value)} value={newReply} />
                      </div>
                      <div className="your-reply-btns">
                        <div className={newReply.length === 0 ? "visibility-hidden" : null}> Save </div>
                      </div>
                    </div>
                    <div className="other-replies">
                      {data[commentIndex + 1].reply.map((i) => (
                        <div className="single-reply">
                          <div className="align-items-center">
                            <img alt="" src={user4} className={`author-avatar ${i.id === 1 ? "you" : null} `} />
                            <div className="reply-info">
                              <div className="flex">
                                <span className="bold"> David </span>
                                <span className="reply-date"> 4d </span>
                                {/* your reply */}
                                {i.id === 1 && (
                                  <div className="flex relative left-100">
                                    <div className="flex">
                                      <img alt="" src={iconCommentEdit} width={16} className="pointer m-r-5" />
                                    </div>
                                    <div className="flex" onClick={() => deleteComment(data[commentIndex + 1].id)}>
                                      <img alt="" src={iconCommentDelete} width={16} className="pointer" />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="flex p-l-35 font-12">{i.reply}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {data.length > 2 && data[commentIndex + 2] && (
            <div className={`single-comment AcommentIndex+2 ${data.length}`}>
              <div>
                <img alt="" src={user4} className="author-avatar" />
              </div>
              <div>
                <div className="comment-info">
                  <span className="bold p-l-0"> Mark </span>
                  <span> 10m </span>
                  <span className="flex">
                    <img alt="" src={iconCommentPlace} width={16} />
                    12:11
                  </span>
                </div>
                <div className="comment-text 03">{data[commentIndex + 2].comment}</div>
              </div>
            </div>
          )}
          {data.length > 3 && data[commentIndex + 3] && (
            <div className="single-comment">
              <div>
                <img alt="" src={user4} className="author-avatar" />
              </div>
              <div>
                <div className="comment-info">
                  <span className="bold"> David </span>
                  <span className="p-l-5"> 1s </span>
                </div>
                <div className="comment-text 04">{data[commentIndex + 3].comment}</div>
              </div>
            </div>
          )}
        </div>
      )}

      {addShowComment && (
        <div className="flex-col">
          <div className="comment-items">
            <div className="single-comment no-comment">
              <div>
                <img alt="" src={user4} className="author-avatar" />
              </div>
              <div>
                <div className="comment-info">
                  <span className="bold p-l-0"> Ely </span>
                  <span> 9m </span>
                  <span className="flex">
                    <img alt="" src={iconCommentPlace} width={16} />
                    05:26
                  </span>
                </div>
                <div className="comment-text 04">{data[2].comment}</div>
              </div>
            </div>
          </div>
          <div className="add-new-comment">
            <div>
              <img alt="" src={user4} className="author-avatar" />
            </div>
            <div className="w-100p">
              <textarea className={newCommentError && "error"} onChange={(e) => setNewComment(e.target.value)} value={newComment} />
              <div className={`red-text bold ${newComment.length !== 0 && "visibility-hidden"} `}> please type something... </div>
              <div>
                <div className="new-comment-btn space-between">
                  <span className="flex w-70" onClick={() => setMarkAsQuestion(!markAsQuestion)}>
                    <img alt="" width={20} className="m-r-3" src={markAsQuestion ? iconQuestionCheck : iconQuestionUnCheck} /> question
                  </span>
                  <span className="flex-end pointer bold w-70" onClick={() => setShowAddComment(false)}>
                    Cancel
                  </span>
                  <div className="w-70 flex-end">
                    {newCommentStatus === "" && (
                      <div
                        className={`send pointer bold ${newComment.length === 0 && "disable"} `}
                        onClick={newComment.length !== 0 ? addNewCommentWithInterval : null}>
                        {" "}
                        Save{" "}
                      </div>
                    )}
                    {newCommentStatus === "sending" && (
                      <span className="flex">
                        <img alt="" src={iconCommentSending} width={16} className="m-r-5 bold" /> Saving
                      </span>
                    )}
                    {/* {newCommentStatus === 'sent' && <img alt="" src={iconCommentSent} width={16} />} */}
                    {newCommentStatus === "error" && <span className="red-text bold">server error</span>}
                  </div>
                  <div
                    className="absolute pointer"
                    style={{
                      bottom: "10px",
                      left: "-70px",
                      backgroundColor: "red",
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                    onClick={() => errorSendNewComment()}>
                    show-error
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="comment-items">
            <div className="single-comment no-comment">
              <div>
                <img alt="" src={user4} className="author-avatar" />
              </div>
              <div>
                <div className="comment-info">
                  <span className="bold p-l-0"> Sara </span>
                  <span> 16m </span>
                  <span className="flex">
                    <img alt="" src={iconCommentPlace} width={16} />
                    15:51
                  </span>
                </div>
                <div className="comment-text 04">{data[2].comment}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Comments;
